import React, { Component } from 'react';
import { Button, Col, Input, Row, Table } from 'antd';

import moment from 'moment';
import { connect } from 'react-redux';

import { BackBtn } from '@comm/BackBtn';
import util from '@util';
import { queryDownloadFundRecordTemplate, queryFundsRecordList } from '@api/finance/funds';
import DetailModal from './ModalDetail';
import CardStatic from './CardStatic';
import ImportExcelModal from './ModalImportExcel';
import ModalRelate from './ModalRelate';
import ModalAdd from '../../capital/detail/ModalDetail';

// import { getAccountInfo } from "../../../../store/modules/account_info";

class FinanceCapitalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      importVisible: false,
      modalRelateVisible: false,
      modalIncomeVisible: false,
      pageNo: 1,
      record: [],
      uuid: '',
      condition: '',
      scrollY: util.pageHeight() - 310,
      unit: '元',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadBooksIncomeList(1);
    // this.props.dispatch(getAccountInfo());
  }

  /**
   * 获取流水记录列表
   */
  loadBooksIncomeList = pageNo => {
    const params = {};
    const { uuid } = this.props.params;
    params.bookUuid = uuid;
    params.condition = this.state.condition;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    this.setState({
      pageNo: current,
    });
    queryFundsRecordList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          record: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  hideModal = () => {
    this.setState({
      modalRelateVisible: false,
      modalIncomeVisible: false,
    });
  };

  showModalRelate = uuid => {
    this.setState({
      modalRelateVisible: true,
      uuid,
    });
  };

  showModalIncome = incomeUuid => {
    this.setState({
      modalIncomeVisible: true,
      incomeUuid,
    });
  };

  search = condition => {
    this.condition = condition;
    this.loadBooksIncomeList(1);
  };

  columns = () => {
    const { unit } = this.state;
    return [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
        width: 250,
        render: (text, record) => {
          return (
            <a onClick={() => this.showModal(record.uuid)}>
              {moment.unix(text / 1000).format('YYYY-MM-DD')}
            </a>
          );
        },
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
        width: 200,
      },
      {
        title: `收入(${unit})`,
        dataIndex: 'money',
        key: 'money',
        width: 200,
        render: text => (
          <a style={{ color: 'green' }}>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</a>
        ),
      },
      {
        title: `支出(${unit})`,
        dataIndex: 'payMoney',
        key: 'payMoney',
        width: 200,
        render: text => (
          <a style={{ color: 'red' }}>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</a>
        ),
      },
      {
        title: `当前余额(${unit})`,
        dataIndex: 'current',
        key: 'current',
        width: 200,
        render: text => <a>{text === 0 ? 0 : util.numberFormat(text, 2, '.', ',')}</a>,
      },
      {
        title: '操作',
        key: 'done',
        render: (text, record) => {
          return (
            <span>
              {!record.incomeUuid ? (
                <a onClick={() => this.showModalRelate(record.uuid)}>关联</a>
              ) : (
                <a onClick={() => this.showModalIncome(record.incomeUuid)}>详情</a>
              )}
            </span>
          );
        },
      },
    ];
  };

  showModal = uuid => {
    this.setState({
      visible: true,
      uuid,
    });
  };

  showImport = () => {
    this.setState({
      importVisible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
      importVisible: false,
      modalRelateVisible: false,
      modalIncomeVisible: false,
    });
  };

  handleSubmit = result => {
    if (result) {
      this.handleCancel();
      this.loadBooksIncomeList();
    }
  };

  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  render() {
    const pagination = {
      defaultPageSize: 15,
      showSizeChanger: false,
      onChange: current => {
        this.loadBooksIncomeList(current);
      },
      current: this.state.pageNo,
      total: this.state.total,
    };
    const { record } = this.state;
    const { scrollY } = this.state;
    const { isFinancialM } = this.props;

    return (
      <div>
        <div>
          <div>
            <Row type="flex" justify="space-between" style={{ marginBottom: '16px' }}>
              <Col>
                <BackBtn />
                <Button icon="import" onClick={this.showImport} style={{ marginLeft: '10px' }}>
                  导入
                </Button>
                <a onClick={() => queryDownloadFundRecordTemplate()} style={{ marginLeft: '10px' }}>
                  模板下载
                </a>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                <Input
                  placeholder="请输入关键字"
                  style={{ width: '300px' }}
                  value={this.state.condition}
                  onChange={this.setCondition}
                />
                <Button
                  type="primary"
                  style={{ marginLeft: '10px' }}
                  onClick={() => this.loadBooksIncomeList(1)}
                >
                  搜索
                </Button>
              </Col>
            </Row>
          </div>
          <CardStatic uuid={this.props.params.uuid} />
        </div>
        <Table
          rowSelection={{}}
          columns={this.columns()}
          dataSource={record}
          pagination={pagination}
          rowKey="uuid"
          rowClassName={row => {
            if (row.ignore === 1) {
              return 'table-ignore-1';
            }
            if (row.ignore === 2) {
              return 'table-ignore-2';
            }
          }}
          scroll={{ y: scrollY }}
        />
        {this.state.visible && isFinancialM ? (
          <DetailModal
            ref={form => {
              this.form = form;
            }}
            handleSubmit={this.handleSubmit}
            uuid={this.state.uuid}
            cancel={this.handleCancel}
          />
        ) : (
          ''
        )}
        {this.state.importVisible ? (
          <ImportExcelModal
            ref={form => {
              this.form = form;
            }}
            handleSubmit={this.handleSubmit}
            uuid={this.props.params.uuid}
            cancel={this.handleCancel}
          />
        ) : (
          ''
        )}

        {this.state.modalRelateVisible ? (
          <ModalRelate
            ref={form => {
              this.form = form;
            }}
            handleSubmit={this.handleSubmit}
            uuid={this.state.uuid}
            compUuid={this.props.params.uuid}
            cancel={this.handleCancel}
          />
        ) : (
          ''
        )}
        {this.state.modalIncomeVisible ? (
          <ModalAdd
            ref={form => {
              this.form = form;
            }}
            handleSubmit={this.handleSubmit}
            data={{}}
            uuid={this.state.incomeUuid}
            cancel={this.handleCancel}
            readOnly
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(state => ({
  isFinancialM: state.account_info.isFinancialM,
  account_info: state.account_info,
  income_info: state.income_info,
}))(FinanceCapitalDetail);



// WEBPACK FOOTER //
// ./src/components/finance/funds/detail/Index.js